<template>
  <div ref="chartRef" class="pie-chart"></div>
</template>

<script>
import * as echarts from "echarts";

export default {
  props:{
    data:{
      type: Array,
      default: () => []
    },
    colors:{
      type: Array,
      default: () => []
    },
    innerRadius:{
      type: Number,
      default: 50
    },
    outerRadius:{
      type: Number,
      default: 85
    }
  },
  data(){
    return{
      myChart: null
    };
  },
  watch:{
    data:{
      deep:true,
      handler(){
        this.initChart();
      }
    }
  },
  mounted() {
    this.initChart();
    window.addEventListener('resize', this.resizeChart);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resizeChart);
    if (this.myChart) {
      this.myChart.dispose();
    }
  },
  methods:{
    initChart(){
      if (this.myChart) {
        this.myChart.dispose();
      }
      this.myChart = echarts.init(this.$refs.chartRef);
      const option = this.getOption();
      this.myChart.setOption(option, true);
    },
    getOption(){
      const { data, colors, innerRadius, outerRadius } = this;
      return{
        tooltip: {
          trigger: 'item',
          formatter: '{b}: {c} ({d}%)',
        },
        series: [
          {
            hoverAnimation: false,
            radius: [innerRadius + '%', outerRadius + '%'],
            name: 'pie',
            type: 'pie',
            clockwise: true,
            startAngle: 90,
            avoidLabelOverlap: false,
            label: {
              show: false,
            },
            labelLine: {
              show: false,
            },
            color: colors,
            itemStyle: {
              borderRadius: 10,
            },
            data: data.map((item) => ({
              value: item.value,
              name: item.name,
              itemStyle: {
                color: item.color || (item.colorStops ? item.colorStops[0] : undefined),
              },
            })),
          },
        ],
      }
    },
    resizeChart() {
      if (this.myChart) {
        this.myChart.resize();
      }
    },
  }
}
</script>

<style scoped lang="less">
/* ponytail: sizing is managed by PieCard via :deep(.pie-chart) */
</style>
